import { render, staticRenderFns } from "./add-game-popup.vue?vue&type=template&id=be4dc15c&scoped=true&"
import script from "./add-game-popup.vue?vue&type=script&lang=js&"
export * from "./add-game-popup.vue?vue&type=script&lang=js&"
import style0 from "./add-game-popup.vue?vue&type=style&index=0&id=be4dc15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4dc15c",
  null
  
)

export default component.exports